import { api } from './api';
import { UserProfile, UpdateProfileInput, PublicUserProfile } from '../Types/api';

export const userService = {
  getProfile: () => api.get<UserProfile>('/users/profile'),

  updateProfile: (input: UpdateProfileInput) => api.put<UserProfile>('/users/profile', input),

  getPublicProfile: (userId: string) => api.get<PublicUserProfile>(`/users/${userId}`),
};
